// extracted by mini-css-extract-plugin
export default {"container":"UserItem_container__y4hwi","item":"UserItem_item__0urJk"};